import { render, staticRenderFns } from "./ScanDetail.vue?vue&type=template&id=374d5420&scoped=true"
import script from "./ScanDetail.vue?vue&type=script&lang=js"
export * from "./ScanDetail.vue?vue&type=script&lang=js"
import style0 from "./ScanDetail.vue?vue&type=style&index=0&id=374d5420&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374d5420",
  null
  
)

export default component.exports